class Piano {
    keys = {};

    constructor() {
        for (let i = 1; i <= 88; i++) {
            let n = this.key(i);
            const isBlackKey = [2, 4, 7, 9, 11].includes(n);
            this.keys[i] = (isBlackKey);
        }
    }

    // Any C is 1, any D is 3, A0 = A1 = A5 = 10
    key(i) {
        return (i > 3) ? (((i - 3) % 12)) : 9 + i;
    }

    octave(keyNumber) {
        if (keyNumber <= 3) { 
            return 0 
        } else {
            let o = Math.ceil((keyNumber - 2) / 12);
            if (this.key(keyNumber) === 0) {
                o-=1;
            }
            return o;
        }
    }

    // A0 = 1
    isBlackKey(keyNumber) {
        return this.keys[keyNumber];
    }

    whiteKeysBefore(keyNumber) {
        return this.whiteKeysBetween(1, keyNumber);
    }

    whiteKeysBetween(min, max) {
        if (Number.isNaN(min) || Number.isNaN(max)) {
            throw new Error(`Min and max can't be NaN, ${min}, ${max}`);
        }
        let count = 0;
        for (let i=min; i<max; i++) {
            const isBlackKey = this.isBlackKey(i);
            if (!isBlackKey) {
                count++;
            }
        }
        return count;
    }

    note(keyNumber) {
        const octave = this.octave(keyNumber);
        const n = this.key(keyNumber);
        const noteName = ['c', 'c#', 'd', 'd#', 'e', 'f', 'f#', 'g', 'g#', 'a', 'a#', 'b'][n === 0 ? 11 : n-1];
        return `${noteName}${octave}`;
    }
}

const PianoUtil = new Piano();
export default PianoUtil;

export function getChartMinMax(notes) {
    let min = 999, max = 0;
    notes.forEach(note => {
        if (note.midi < min) {
            min = note.midi;
        }
        if (note.midi > max) {
            max = note.midi;
        }
    });
    // midi note to piano key number
    min -= 20; max -= 20;
    if (PianoUtil.isBlackKey(min)) {
        min -= 1;
    }
    if (PianoUtil.isBlackKey(max)) {
        max += 1;
    }
    return { min, max };
}

/* 
    F in G major is F#
*/
export function applyKey(pitch, key) {
    switch (key) {
        case 'Em':
        case 'G': {
            if (pitch.step === 'F') {
                return { ...pitch, step: 'F#' }
            } else {
                return pitch;
            }
        }
        case 'F': 
            if (pitch.step === 'B') {
                return { ...pitch, step: 'Bb' }
            } else {
                return pitch;
        }
        case 'Am':
        case 'C':
        default: return pitch;
    }
}